import LocalisationService from '@/services/LocalisationService'
import MarkdownService from '@/services/MarkdownService';

const localisationService = new LocalisationService()
const markdownService = new MarkdownService()

const state = {
    translations: {},
    fetched: false,
}

const actions = {
    // eslint-disable-next-line consistent-return
    async get({ commit }, { lang, cc, api_key }) {
        // eslint-disable-next-line no-return-await
        return await new Promise((resolve, reject) => {
            localisationService.get({ lang, cc, api_key })
                .then((response) => {
                    const translations = {}

                    response.data.response.forEach((item) => {
                        translations[item.sentence_key] = item.translation
                    })

                    commit('updateTranslations', translations)
                    commit('updateFetched', true)
                    resolve()
                })
                .catch((error) => {
                    commit('updateFetched', false)
                    reject(error)
                })
        })
    },
}

const mutations = {
    updateFetched(state, payload) {
        state.fetched = payload
    },
    updateTranslations(state, payload) {
        Object.assign(state.translations, payload)
    },
}

const getters = {
    fetched(state) {
        return state.fetched
    },
    translate: (state) => (key, replacements) => {
        let translation = state.translations[key];

        if (replacements !== undefined && replacements !== null) {
            const findAndReplace = Object.entries(replacements)

            findAndReplace.forEach((element) => {
                // eslint-disable-next-line no-template-curly-in-string
                translation = translation.replace(`{{${element[0]}}}`, `<strong>${element[1]}</strong>`)
            })
        }

        return translation
    },
    translateWithMarkdown: (state) => (key, replacements) => {
        let translation = state.translations[key];

        if (replacements !== undefined && replacements !== null) {
            const findAndReplace = Object.entries(replacements)

            findAndReplace.forEach((element) => {
                // eslint-disable-next-line no-template-curly-in-string
                translation = translation.replace(`{{${element[0]}}}`, element[1])
            })
        }

        return markdownService.convert(translation)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
